import React from 'react';

const HowThisWorks = ({dietPlan}) => {
  return(
    <div className='plan-highlights-box mb-4'>
      <h3>How this works</h3>
      {
        dietPlan.dietPlanType === 'one_month_smart_diet_plan' ?
          <ul className="timeline">
            <li>Complete a short assessment detailing out your preferences and goals</li>
            <li>This will help us to curate a personalised diet plan for you</li>
            <li>Your daily meal logs will help the diet plan in customising and improving it further</li>
            <li>Your diet plan will be generated immediately after an assessment</li>
          </ul> :
          <ul className="timeline">
            <li>Select a plan that works for you</li>
            <li>Select your free smart device</li>
            <li>Help us fill the form sent to you via Whatsapp and SMS so that we can complete your assessment</li>
            <li>Recieve your DrTrust product within 5-7 days</li>
            <li>Recieve a call within 48-72 hours from our nutritionist to better customise your plan</li>
          </ul>
      }
    </div>
  );
};

export default HowThisWorks;